import React from 'react';
import Datatable from '../../../../components/molecules/datatable';
import { TableColumns } from '../../configuration';
import ActionsBlock from './ActionsBlock';
import * as MessageIncomingSelectors from '../../../../redux/reducers/message_incoming_reducer/selectors';
import { useDispatch } from 'react-redux';
import MessageIncomingActions from '../../../../redux/reducers/message_incoming_reducer/actions';
import useStyles from './styles';
import Filter from '../filter';
import useQuery from 'custom_hooks/useQuery';
import { parseQueryDate } from '../../../../utils/dates';

export default function DatatableList() {
  const result = MessageIncomingSelectors.useGetMessageIncomingList();
  const paging = result.data?.paging;
  const dispatch = useDispatch();
  const sortField = React.useRef<string>(TableColumns[0].id);
  const sortType = React.useRef<'asc' | 'desc'>('desc');
  const classes = useStyles();

  var query = useQuery();
  const messageId = query.get('messageId');
  const originatingCountry = query.get('originatingCountry');
  const messageType = query.get('messageType');
  const status = query.get('status');
  const date_from = query.get('date_from');
  const date_to = query.get('date_to');
  let searchParams = {
    ...(messageId && { messageId }),
    ...(originatingCountry && { originatingCountry }),
    ...(messageType && { messageType }),
    ...(status && { status }),
    ...(date_from && { date_from: parseQueryDate(date_from) }),
    ...(date_to && { date_to: parseQueryDate(date_to) }),
  };

  return (
    <React.Fragment>
      <Filter
        messageId={messageId}
        originatingCountry={originatingCountry}
        messageType={messageType}
        status={status}
        date_from={parseQueryDate(date_from)}
        date_to={parseQueryDate(date_to)}
      />
      <Datatable
        loading={true}
        sorting={{
          sortField: sortField.current,
          order: sortType.current,
        }}
        paging={paging}
        data={result.data?.items || []}
        columns={TableColumns}
        changePageHandle={(selectedPage, pageSize, order, _sortField) => {
          sortType.current = order;
          sortField.current = _sortField;
          dispatch(
            MessageIncomingActions.fetchMessageIncomingAction({
              sortField: _sortField,
              page: selectedPage,
              pageSize: pageSize,
              order: order,
              ...searchParams,
            })
          );
        }}
      />
    </React.Fragment>
  );
}

export { ActionsBlock };
